import React from 'react';
import type { HealthStatus } from '../../types/monitor';

/**
 * Proposed status glyph set — the beacon alone, at four levels of signal.
 * Healthy carries both arc pairs, warning one, critical is struck through,
 * paused is unlit.
 */
export function Beacon({
  status,
  className = ''
}: {
  status: HealthStatus;
  className?: string;
}) {
  const lit = status !== 'paused';
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" focusable="false" data-id="element-176" data-mp="hivxtvba440l">
      {lit ? <circle cx="12" cy="12" r="2.7" fill="currentColor" data-id="element-177" data-mp="clvsjmm975aj" /> : <circle cx="12" cy="12" r="2.7" stroke="currentColor" strokeWidth="1.6" data-id="element-178" data-mp="ra0bmrp7xitu" />}

      {(status === 'healthy' || status === 'warning') && <>
          <path d="M8.2 8.2a6 6 0 0 0 0 7.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" data-id="element-179" data-mp="3uw7hfjwy50hq" />
          <path d="M15.8 8.2a6 6 0 0 1 0 7.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" data-id="element-180" data-mp="25inucqv60gig" />
        </>}

      {status === 'healthy' && <>
          <path d="M5.4 5.6a10 10 0 0 0 0 12.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.5" data-id="element-181" data-mp="2fabq33yr8jpq" />
          <path d="M18.6 5.6a10 10 0 0 1 0 12.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.5" data-id="element-182" data-mp="1mmpdx7bgo6r9" />
        </>}

      {status === 'critical' && <path d="M5.6 18.4 18.4 5.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" data-id="element-183" data-mp="20l5k8x5evv8v" />}
    </svg>;
}